var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rackContainer" }, [
    _c(
      "div",
      {
        staticClass: "titleContainer",
        class: _vm.rack.active ? "active-rack" : null,
        on: {
          contextmenu: function($event) {
            return _vm.openRackMenu($event)
          }
        }
      },
      [_c("h5", [_vm._v(_vm._s(_vm.rack.ra_label))])]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rackDiagramContainer" },
      _vm._l(_vm.rack.drawers.slice().reverse(), function(position, index) {
        return _c("rack-position", {
          key: index,
          attrs: { position: position },
          on: {
            "open-menu": _vm.openMenu,
            "set-active-position": _vm.setActivePosition,
            "start-drag": _vm.startDrag,
            "end-drag": _vm.endDrag
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37c6ad16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c6ad16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/Rack.vue
// module id = null
// module chunks = 